import { gql } from 'apollo-angular';

const GET_ASSET_BY_TYPE = gql`
  query AssetsByType($assetType: AssetType!) {
    assetsByType(assetType: $assetType) {
      id
      name
      tags
      description
      parameters
      createdAt
      launchURL
      updatedAt
      status
      creator
      type
    }
  }
`;

const GET_ASSET_BY_TYPE_PAGINATED = gql`
  query AssetsByType(
    $assetType: AssetType!,
    $page: Int,
    $limit: Int,
    $connectionId: String,
    $searchCriteria: String,
    $filters: JSON
  ) {
    assetsByType(
      assetType: $assetType,
      page: $page,
      limit: $limit,
      connectionId: $connectionId,
      searchCriteria: $searchCriteria,
      filters: $filters
    ) {
      id
      name
      tags
      description
      parameters
      createdAt
      launchURL
      updatedAt
      status
      creator
      type
    }
  }
`;


const GET_ASSET_BY_ID = gql`
  query asset($assetId: String!) {
    asset(assetId: $assetId) {
      id
      name
      description
      parameters
      createdAt
      launchURL
    }
  }
`;

const CREATE_ASSET_BY_TYPE = gql`
  mutation createAsset($createAssetData: CreateAssetInput!) {
    createAsset(createAssetData: $createAssetData) {
      id
      name
    }
  }
`;

const UPDATE_ASSET = gql`
  mutation updateAsset($updateAssetData: UpdateAssetInput!) {
    updateAsset(updateAssetData: $updateAssetData) {
      id
      name
      description
      tags
      status
      access {
        collaboratorIds
      }
    }
  }
`;
const DELETE_ASSET_BY_ID = gql`
  mutation DeleteAsset($assetId: String!) {
    deleteAsset(assetId: $assetId)
  }
`;
const FORCE_DELETE_ASSET = gql`
  mutation forceDeleteAsset($deleteAssetInput: DeleteAssetInput!) {
    forceDeleteAsset(deleteAssetInput: $deleteAssetInput) {
      id
      name
      type
      status
    }
  }
`;

const GET_ASSET_ID_NAME_BY_TYPE = gql`
  query AssetsByType($assetType: AssetType!) {
    assetsByType(assetType: $assetType) {
      id
      name
    }
  }
`;
export {
  GET_ASSET_BY_TYPE,
  GET_ASSET_BY_ID,
  CREATE_ASSET_BY_TYPE,
  UPDATE_ASSET,
  DELETE_ASSET_BY_ID,
  FORCE_DELETE_ASSET,
  GET_ASSET_BY_TYPE_PAGINATED,
  GET_ASSET_ID_NAME_BY_TYPE
};
